import { render, staticRenderFns } from "./ByProductTab.vue?vue&type=template&id=65c7234e&scoped=true"
import script from "./ByProductTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ByProductTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ByProductTab.vue?vue&type=style&index=0&id=65c7234e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c7234e",
  null
  
)

export default component.exports